import "./card.scss";

import { bemCN } from "../../config/bem-classname";

import { FC, ReactNode } from "react";

type CardProps = {
  children: ReactNode;
};
const cardCN = bemCN("card");

export const Card: FC<CardProps> = ({ children }) => {
  return <div className={cardCN()}>{children}</div>;
};
